export const GENERATE_SUMMARY = "GENERATE_SUMMARY";
export const GENERATE_SUMMARY_SUCCESS = "GENERATE_SUMMARY_SUCCESS";
export const GENERATE_SUMMARY_FAILURE = "GENERATE_SUMMARY_FAILURE";
export const GET_SUMMARY_FAILURE = "GET_SUMMARY_FAILURE";
export const SET_SUMMARIES = "SET_SUMMARIES";
export const GET_SUMMARIES = "GET_SUMMARIES";
export const RESET_ERROR = "RESET_ERROR";
